<template>
  <div class="blue-growth-panel">
    <vs-divider position="left">When</vs-divider>
    <section class="timeline">
      <range-slider
        :id="'dataHubSlider'"
        :range-data="timelineData"
        :theme="'msp'"
        @change="updateActiveMomentId"
      ></range-slider>
    </section>
    <section id="data">
      <bluegrowth-past
        v-if="activeMomentId === moments.past.id"
        name="past"
        :moment-id="moments.past.id"
      ></bluegrowth-past>
      <bluegrowth-present
        v-if="activeMomentId === moments.present.id"
        name="present"
        :moment-id="moments.present.id"
      ></bluegrowth-present>
      <bluegrowth-short-term
        v-if="activeMomentId === moments.shortTerm.id"
        name="shortTerm"
        :moment-id="moments.shortTerm.id"
      ></bluegrowth-short-term>
      <bluegrowth-future
        v-if="activeMomentId === moments.climateChange.id"
        name="climateChange"
        :moment-id="moments.climateChange.id"
      ></bluegrowth-future>
    </section>
  </div>
</template>
<script>
import BlueGrowthPast from "@/components/BlueGrowthPast";
import BlueGrowthPresent from "@/components/BlueGrowthPresent";
import BlueGrowthShortTerm from "@/components/BlueGrowthShortTerm";
import BlueGrowthFuture from "@/components/BlueGrowthFuture";
import RangeSlider from "@/components/ui/RangeSlider";
import { MOMENTS, TIMELINE_MOMENTS } from "@/constants.js";
export default {
  components: {
    "bluegrowth-past": BlueGrowthPast,
    "bluegrowth-present": BlueGrowthPresent,
    "bluegrowth-short-term": BlueGrowthShortTerm,
    "bluegrowth-future": BlueGrowthFuture,
    "range-slider": RangeSlider
  },
  data() {
    return {
      activeMomentId: TIMELINE_MOMENTS[0].id,
      timelineData: TIMELINE_MOMENTS,
      moments: MOMENTS
    };
  },
  methods: {
    updateActiveMomentId(id) {
      this.activeMomentId = id;
    }
  }
};
</script>
<style scoped>
.blue-growth-panel {
  flex: 1;
  margin-left: 20px;
  margin-right: 20px;
  font-size: 0.8rem;
}
</style>
